import React from 'react';

import { ValueBox, ValueSelectInput } from '@candu-ai/craft/ui';
import { Action, INTERACTION_TYPES } from 'craft/types';

import { getDefaultAction } from './getDefaultAction';
import { getInteractionFromAction, useAvailableInteractions } from './useAvailableInteractions';
import { useGenerateInteractionLabelName } from './useGenerateInteractionLabelName';

interface Props {
  nodeIds: string[];
  noRadiusBottom?: boolean;
  action?: Action;
  style?: object;
  isStandalone?: boolean;
  onChange: (newAction: any) => void;
}

type Item = {
  value: INTERACTION_TYPES;
  label: string;
};

export const InteractionDropdown = ({ nodeIds, action, onChange, isStandalone = true }: Props) => {
  const interactions = useAvailableInteractions(nodeIds, action);
  const getNewInteractionLabelName = useGenerateInteractionLabelName(nodeIds);

  const options = interactions.map(({ id, name }) => ({ value: id, label: name }));

  const interaction = getInteractionFromAction(action);

  const onSetInteraction = (selected: { value?: INTERACTION_TYPES } | null) => {
    const defaultAction = getDefaultAction(selected?.value, getNewInteractionLabelName('Clicked'));
    onChange(defaultAction);
  };

  return (
    <ValueBox isInGroup={isStandalone ? false : { isFirst: true }}>
      <ValueSelectInput<Item>
        scale="small"
        placeholder="None"
        items={options}
        selectedItem={options.find(({ value }) => value === interaction)}
        onSelect={onSetInteraction}
        calloutOffset="xxs"
      />
    </ValueBox>
  );
};
